import { ForkEffect, put, takeLatest } from 'redux-saga/effects';

import { PayloadAction } from '@reduxjs/toolkit';
import { AnalyticsBoardSetModel, BoardDefaults } from '@common/types/dictionaries/analytics';
import { IndexedArray } from '@common/types';

import { AnalyticsActions } from '../types/actions';
import { IAnalyticsCommonAPI } from '../types/api';
import { sortListBySerial } from '../utils/sort-boards';

export const getBoardSetsSuccessCommonWatcher = (
  api: IAnalyticsCommonAPI,
  actions: AnalyticsActions
): (() => Generator<ForkEffect<never>, void>) => {
  function* worker(action: PayloadAction<{ data: IndexedArray<AnalyticsBoardSetModel> } & BoardDefaults>) {
    const { success, failure, fulfill } = actions.analyticsCommonSelectBoardSetRoutine;
    const { payload } = action;

    try {
      const boardSetIdToSelect = payload?.defaults?.boardSetId || sortListBySerial(payload.data)[0]?.ID;
      yield put(success({ ID: boardSetIdToSelect, defaults: { ...action.payload.defaults } }));
    } catch (error) {
      console.error(error);
      yield put(failure(error));
    } finally {
      yield put(fulfill());
    }
  }

  function* watcher() {
    yield takeLatest(actions.analyticsCommonGetBoardSetsRoutine.SUCCESS, worker);
  }

  return watcher;
};
